import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse, EONE_DIMENSIONAL_METRICS, IMetricsSession, IPKTeamLeaderboardData } from '@umu/umu-types';

export interface ILeaderboardOutput {
    metrics_type: EONE_DIMENSIONAL_METRICS;
    list: IPKTeamLeaderboardData[];
    session_list: IMetricsSession[];
}

export const getPkLeaderboard = (input: {
    course_id: string;
    activity_id: string;
    metrics_type: EONE_DIMENSIONAL_METRICS;
}): Promise<IResponse<ILeaderboardOutput>> => {
    const param = {
        ...input,
        page: 1,
        size: 100,
    };
    return fetchData(API.GET_COURSE_PK_LEADERBOARD, JSON.stringify(param)).then((res: IResponse<ILeaderboardOutput>) => {
        res.data.metrics_type = input.metrics_type;
        return res;
    });
};
